// React Hook Form consts
export const mode = 'all';
export const reValidateMode = 'onChange';

export const STEP_1 = 'splash';
export const STEP_LOADING = 'loading';
export const STEP_HOUSEHOLD = 'household';
export const STEP_DELIVERY = 'deliveryDay';
export const STEP_SERVINGS = 'servings';
export const STEP_DIET = 'diet';

// rolled out to BAY_AREA, NEW_YORK, LOS_ANGELES
export const PRICING_EXPERIMENT_REGION_IDS = [1, 2, 8];
// Launching Jan 2026 in BOSTON DC_AREA AUSTIN
export const JAN_LAUNCH_REGION_IDS = [7, 9, 10];
